import { useEffect, useState } from "react";

// Détecte si le viewport est « mobile » (< breakpoint). Utilisé pour basculer
// certaines vues denses (planning) vers un affichage adapté au doigt. Écoute les
// changements de taille via matchMedia (léger, sans dépendance).
// Aligné sur le breakpoint Tailwind `md` (768px) : < 768px => mobile.
export function useIsMobile(breakpoint = 768) {
  const query = `(max-width: ${breakpoint - 1}px)`;
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e) => setIsMobile(e.matches);
    // Compatibilité navigateurs (addEventListener récent + fallback addListener)
    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else mql.addListener(onChange);
    setIsMobile(mql.matches);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener("change", onChange);
      else mql.removeListener(onChange);
    };
  }, [query]);

  return isMobile;
}

export default useIsMobile;
